<template>
  <hg-topbar>
    <p class="tw-m-0">
      Benötigst du Hilfe?
      <a class="tw-text-teal-500" href="tel:+4923018939742">+49 2301 8939742</a>
      - täglich von 8 bis 22 Uhr.
    </p>
  </hg-topbar>
</template>

<script>
export default {}
</script>
